export default __webpack_public_path__ + "static/media/gel-buffer-13.3687c79f.svg";